import { useEffect, useState } from "react";
import { InventoryStockUpdate } from "../../Interfaces/Warehouse";
import config from "../../config";
import fetchWithAuth from "../../services/fetchWithAuth";
import { Product } from "../../Interfaces/Product";
import UpdateInventoryStockPendingDisplay from "../../components/Warehouse/UpdateInventoryStock/UpdateInventoryPendingDisplay";
import UpdateInventoryStockInput from "../../components/Warehouse/UpdateInventoryStock/UpdateInventoryStockInput";
import "./UpdateInventoryStock.css";
import { LoggedInAccount } from "../../Interfaces/AccountUsers";
import { getCurrentlyLoggedInUser } from "../../CommonFunctions";
interface UpdateInventoryStockProps {
  onClose: () => void;
}

const FUND_ID_NO_RESTRICTIONS = 1;

const UpdateInventoryStock: React.FC<UpdateInventoryStockProps> = ({
  onClose,
}) => {
  const [updateInventoryStock, setUpdateInventoryStock] = useState<
    InventoryStockUpdate[]
  >([]);
  const [products, setProducts] = useState<Product[]>([]);
  const [loggedInAccount, setLoggedInAccount] =
    useState<LoggedInAccount | null>(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetchWithAuth(
          `${config.API_BASE_URL}products/fundraiser/${FUND_ID_NO_RESTRICTIONS}?include_inactive=true`,
        );

        if (response.status === 200) {
          const data = await response.json();
          setProducts(data);
        } else {
          console.error("Failed to fetch products:", response.status);
        }
      } catch {
        console.log("Failed to fetch products");
      }
    };
    const fetchLoggedInAccount = async () => {
      const account = await getCurrentlyLoggedInUser();
      setLoggedInAccount(account);
    };
    fetchLoggedInAccount();
    fetchProducts();
  }, []);

  return (
    <div className="update-inventory-container" onClick={onClose}>
      <div
        className="update-inventory-popup"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="update-inventory-header">Update Inventory Stock</div>
        <div className="update-inventory-sub-text">
          Note: Positive numbers should be used to indicate additions to
          inventory, and negative integers should be used to indicate
          subtractions in inventory
        </div>
        <UpdateInventoryStockInput
          products={products}
          updateInventoryStock={updateInventoryStock}
          setUpdateInventoryStock={setUpdateInventoryStock}
          loggedInAccount={loggedInAccount}
        />
        <UpdateInventoryStockPendingDisplay
          products={products}
          updateInventoryStock={updateInventoryStock}
          setUpdateInventoryStock={setUpdateInventoryStock}
        />
      </div>
    </div>
  );
};

export default UpdateInventoryStock;
